import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import BlocsPage from "./blocs/BlocsPage";

import AdminNav from "./AdminNav";

const AdminPage = (props) => {
  const { children } = props;

  if (children.type === BlocsPage) {
    return children;
  }

  return (
    <div>
      <div className="page-header">
        <div className="main clearfix">
          <div className="main-name">
            <h2>
              <FormattedMessage id="admin.title" />
            </h2>
          </div>
        </div>
        <AdminNav />
      </div>
      {!!children ? <div className="sub-container">{children}</div> : ""}
    </div>
  );
};

AdminPage.propTypes = {
  children: PropTypes.node,
};

export default AdminPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/AdminPage.js